





















import Vue from 'vue';
import Scene01 from '../views/Scene01.vue'
import Scene02 from '../views/Scene02.vue'
import Scene03 from '../views/Scene03.vue'

export default Vue.extend({
  name: 'HelloWorld',
  components: {
    Scene01,
    Scene02,
    Scene03,
  },
  props: {
    msg: String,
  },
});
